import { type RootState } from "../../redux/store";

export const selectSeriesTree = (state: RootState) => state.srp.seriesTree.tree;

export const isComingFromSeriesTreeClick = (state: RootState) => state.srp.seriesTree.isSeriesSelected;
